(ns manage.template-table.db
  (:require [common.db.table.backend :refer [map->InMemoryBackend]]
            [common.db.table.core :refer [register-table]]
            [re-frame.core :as rf]))

(defn after-effects-templates? [channel]
  (not= "display" channel))

(defn template-table-ns [channel]
  (if (after-effects-templates? channel)
    :table.after-effects-templates
    :table.html-templates))

(def in-memory-backend
  (map->InMemoryBackend
   {:on-init [:resource.template/get-all]
    :on-change [:resource.template/get-all]}))

(register-table
 {:namespace :table.after-effects-templates
  :value-sub [:table.after-effects-templates/value-sub]
  :initial-sort {:column :updatedAt :direction :desc}
  :initial-search {:column :name :term ""}
  :backend in-memory-backend})

(register-table
 {:namespace :table.html-templates
  :value-sub [:table.html-templates/value-sub]
  :initial-sort {:column :updatedAt :direction :desc}
  :initial-search {:column :name :term ""}
  :backend in-memory-backend})

(rf/reg-sub :table.after-effects-templates/value-sub
  :<- [:resource.template/all]
  (fn [templates _]
    (update templates :value (fn [temps]
                               (filter #(= "after-effects" (get-in % [:latestRevision :templateType])) temps)))))

(rf/reg-sub :table.html-templates/value-sub
  :<- [:resource.template/all]
  (fn [templates _]
    (update templates :value (fn [temps]
                               (remove #(= "after-effects" (get-in % [:latestRevision :templateType])) temps)))))
